// import Card from "../components/common/Card"
import DashboardLanding from "../components/dashboard/DashboardLanding"
// import Grid from "../components/fragments/Grid"
import { useNavigate } from "react-router-dom"
import PageTitle from "../components/fragments/PageTitle"
import Button from "../components/common/Button"
import WorkQStatusExport from "../layout/WorkQStatusExport"

import classes from './DashboardPage.module.css'

const DashboardPage = () => {
    const navigate = useNavigate()

    return <>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
            <PageTitle isContainer={true}>my<span className={classes.highligth}>eCM</span> Dashboard</PageTitle>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                <Button click={() => navigate('/release-notes')} btnStyle={'btn_light_grey'}>
                    <i className="ti ti-clipboard-list"></i>
                    Release Notes
                </Button>
                <WorkQStatusExport />
            </div>
        </div>
        <DashboardLanding />
    </>
}

export default DashboardPage
